export default "__VITE_ASSET__BHfZ_I6o__"